import { POI_TYPES } from '../constants/poiTypes';
import { logError, logInfo } from './logger';

export const generatePOIId = (type, routeNumber, sequence) => {
  const prefix = POI_TYPES[type]?.prefix || 'XX';
  const route = String(routeNumber).padStart(2, '0');
  const seq = String(sequence).padStart(4, '0');
  return `${prefix}-${route}-${seq}`;
};

export const getElevation = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://api.open-elevation.com/api/v1/lookup?locations=${latitude},${longitude}`
    );
    if (!response.ok) throw new Error('Failed to fetch elevation');
    const data = await response.json();
    return data.results?.[0]?.elevation;
  } catch (error) {
    logError('Failed to get elevation:', error);
    return null;
  }
};

export const getNearestAddress = async (latitude, longitude) => {
  try {
    if (!latitude || !longitude || isNaN(latitude) || isNaN(longitude)) {
      throw new Error('Invalid coordinates');
    }

    console.log('Getting address for:', latitude, longitude);
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    if (!response.ok) {
      console.error('Address lookup failed:', response.status);
      throw new Error('Failed to fetch address');
    }
    const data = await response.json();
    console.log('Address lookup response:', data);
    return data.display_name || 'Address not found';
  } catch (error) {
    logError('Failed to get address:', error);
    return 'Failed to get address';
  }
};